export default __webpack_public_path__ + "/dist/images/engage-icon.4d47509e24fad4484b8d916c4767eafd.svg";